var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.strike)?_c('strike',[_vm._t("default")],2):_c('span',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }